import { FC } from 'react';
import AppProvider from '@/core/providers/app.provider';
import AppRouter from '@/app/router/app.router';

interface AppProps {

}

const App: FC<AppProps> = ({ }) => {
  return (
    <>
      <AppProvider>
        <AppRouter />
      </AppProvider>
    </>
  );
};

export default App;